import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import Creatable from "react-select/creatable";
import { minDate } from "../../../Constants/Constants";

const AddProductDetailsModal = ({ getData, formRef }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [party, setParty] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const [partyNameId, setPartyNameId] = useState("");
  const [partyName, setPartyName] = useState([]);
  // console.log(partyName)
  const [partyID, setPartyId] = useState("");
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState("");
  const [selectedPartyName, setSelectedPartyName] = useState(null);

  const [materialId, setMaterialID] = useState("");
  const [rowAddData, setRowAddData] = useState({
    quantity: "",
    date: "",
    // isChemical: 0
  });
  // console.log(partyName)

  function resetFileds() {
    setSelectedCompanyId("");
    setProductId("");
    setRowAddData({
      quantity: "",
      date: "",
    });
  }

  const handleMaterialChange = (e) => {
    setMaterialID(e.target.value);
  };

  const handleProductChange = (e) => {
    setProductId(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { quantity, date } = rowAddData;

    const formetdate = moment.utc(date).format("YYYY-MM-DD").toString();

    let BASE_URL =
      SERVER_URL + `/api/product-details/product-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        product_name_id: productId,
        quantity,
        date: formetdate,
        // isChemical
      }),
    });
    const response = await res.json();

    if (res.ok) {
      resetFileds();
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getSingleMaterialName = async (selectedOption) => {
    if (selectedOption && selectedOption.id) {
      setSelectedPartyName(selectedOption);
      setPartyId(selectedOption.id);
      let BASE_URL = SERVER_URL + `/api/raw-mat/materialName/${user_id}`;
      const res = await fetch(BASE_URL, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          party_name_id: selectedOption.id,
        }),
      });
      const response = await res.json();

      if (res.ok) {
        setParty(response.data);
      } else {
        toast.error(response.message);
      }
    } else {
      console.error("Invalid selected option:", selectedOption);
      // Handle the case where selectedOption is null or id is not available
    }
  };

  const getProductDetails = async (e) => {
    setSelectedCompanyId(e.target.value);
    const BASE_URL = SERVER_URL + `/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: e.target.value,
      }),
    });
    const result = await res.json();
    // console.log(result.data)
    if (res.ok) {
      setProduct(result.data);
    } else {
      setProduct([]);
    }
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="productModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Product Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Product Details</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Company">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) => getProductDetails(e)}
                              value={selectedCompanyId}
                              id="Company"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length &&
                                company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="product">Product Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleProductChange}
                              value={productId}
                              id="product"
                              required
                            >
                              <option value="">Select Product Name</option>
                              {product &&
                                product?.length &&
                                product?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.size}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="incoming">Quantity</label>
                            <input
                              type="number"
                              className="form-control"
                              name="quantity"
                              id="incoming"
                              placeholder="Quantity"
                              onChange={handleChange}
                              value={rowAddData.quantity}
                              required
                              min="1"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Date">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="Date"
                              min={minDate}
                              max={new Date().toISOString().split("T")[0]}
                              onChange={handleChange}
                              value={rowAddData.date}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="product_type">Product Type</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="isChemical"
                              value={rowAddData.isChemical}
                              onChange={handleChange}
                              id="product_type"
                            >
                              <option value="0">Regular</option>
                              <option value="1">Seasonal</option>
                            </select>
                          </div>
                        </div> */}
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label>Party Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) => getSingleMaterialName(e)}
                              value={partyID}
                            >
                              <option>Select</option>
                              {partyName?.map((item, id) => {
                                return (
                                  <>
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.party_name}`}</option>
                                  </>
                                );
                              })}
                            </select>
                            <Creatable
                              isClearable
                              onChange={getSingleMaterialName}
                              // onCreateOption={handleCreate}
                              options={partyName}
                              value={selectedPartyName}
                              // menuIsOpen={true}
                              menuPosition="fixed"
                            />
                          </div>
                        </div> */}
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label>Material Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleMaterialChange}
                              value={materialId}
                            >
                              <option>Select</option>
                              {party?.map((item, id) => {
                                return (
                                  <>
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.material_name}`}</option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div> */}
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProductDetailsModal;
